import { ArrowPathIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedDeliverableMatchStatusChangedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityStatusTransition,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatStatus } from '../activity-feed-v2/utils';

export interface DeliverableMatchStatusChangedEventProps {
  event: DiscriminatedDeliverableMatchStatusChangedEvent;
}

export const DeliverableMatchStatusChangedEvent: React.FC<
  DeliverableMatchStatusChangedEventProps
> = ({ event }) => {
  const { old_status, new_status } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-cyan-100">
          <ArrowPathIcon className="h-4 w-4 text-cyan-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <div className="flex items-center gap-3">
        {old_status && new_status && (
          <ActivityStatusTransition
            from={formatStatus(old_status)}
            to={formatStatus(new_status)}
          />
        )}
      </div>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Deliverable Match Status Changed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
